import { variables } from './common/variables';

import {
  cl,
  dmsToLonLat,
  urlMapsSelector,
  sortArray,
  convertLong,
  convertLat,
  trimToLowerCase,
  makeScrollbar,
  ajax
} from './common/functions';

import { map, markersCluster } from './components/leaflet/leaflet__map-init';
import { makeMarkerIcon } from './components/leaflet/markerIcon';
import { search } from './components/search';
import { createFilters } from './components/filters';
import { loader } from './components/loader';
import { geolocation } from './components/geolocation';
import { resetLocation } from './components/resetLocation';
import { listEvent, markerEvent, markerClusterEvents } from './components/events';

if (document.getElementById("map")) {
  if (!!variables) {
    if (variables.shortcodeTypeValue) {
      /*------------ [AJAX] success------------*/
      const success = data => {
        /*------------ [MAIN DATAS] ------------*/
        cl(data);
        const types = data.types;
        const entities = data.entities;
        const storesContainer = document.getElementById('stores__container');
        //clear des markers
        const markersLayer = new L.LayerGroup();
        markersLayer.clearLayers();

        /*------------ [LOADER] ------------*/
        loader();

        //sort par ordre alphabetique
        sortArray(entities);

        [...entities].forEach(entity => {
          //json datas
          let { id, name, latitude: lat, longitude: long, type, color, category, secondary_type, secondary_color, address, website, phone, schedule, fullSchedule } = entity;
          color = !!color ? color : '';
          address = !!address ? address : '';
          website = !!website ? website : '';
          phone = !!phone ? phone : '';
          schedule = !!schedule ? schedule : '';
          fullSchedule = !!fullSchedule ? fullSchedule : '';
          secondary_color = !!secondary_color ? secondary_color : '';
          secondary_type = !!secondary_type ? secondary_type : '';

          // Creation des gradients pour les markers
          let bgColor = "";
          if (color === "") {
            bgColor = `linear-gradient(to right, ${secondary_color}, ${secondary_color})`;
          } else if (secondary_color === "") {
            bgColor = `linear-gradient(to right, ${color}, ${color})`;
          } else if (color === "" && secondary_color === "") {
            bgColor = `linear-gradient(to right, ${variables.primaryColor}, ${variables.primaryColor})`;
          } else {
            bgColor = `linear-gradient(to right, ${color}, ${secondary_color})`;
          }
          const colorArray = [color, secondary_color];

          if (type) {
            //remplissage des array
            variables.arrayTypesCategories.push([category, type, secondary_type]);
            variables.arrayCategories.push(category);

            type = !!type ? trimToLowerCase(type) : '';
            secondary_type = !!secondary_type ? trimToLowerCase(secondary_type) : '';
            variables.shortcodeTypeValue = trimToLowerCase(variables.shortcodeTypeValue);

            if (
              variables.shortcodeTypeValue.includes(type)
              || variables.shortcodeTypeValue.includes(secondary_type)
              || variables.shortcodeTypeValue.includes('all')
            ) {
              //traitement des coordonnées
              if (long && lat) {
                //traitement des coordonées
                const latitude = dmsToLonLat(convertLat(lat).lat);
                const longitude = dmsToLonLat(convertLong(long).long);

                const fullScheduleClosed = Object.keys(fullSchedule).every((k) => { return fullSchedule[k] === 'Fermé' });

                const websiteLink = !!website ? `<a href="${website}" target="_blank" class="gl-popup__website">Website</a>` : '';
                const addressLink = !!address ? `<p class="gl-popup__address"><a href="${urlMapsSelector(latitude, longitude)}" target="_blank">${address}</a></p>` : '';
                const phoneTag = !!phone ? `<a href="tel:${phone}" class="gl-popup__phone">${phone}</a>` : '';
                const scheduleTag = !!schedule ? `<p class="gl-popup__schedule">${schedule}</p>` : '';

                //creation du marker
                const marker = L.marker([latitude, longitude], {
                  tags: [type, secondary_type], //pour les filtres
                  name: name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), // pour la recherche
                  icon: makeMarkerIcon(id, [type, secondary_type], colorArray, null, null),
                  markerId: `${id}`
                }).bindPopup(
                  `<div class="gl-popup ${type} ${secondary_type}" style="--markerColor:${bgColor};">
                    <h2 class="gl-popup__title">${name}</h2>
                    ${addressLink}
                    ${!fullScheduleClosed ? scheduleTag : ''}
                    ${phoneTag}
                    ${websiteLink}
                  </div>`);

                //append des markers à un groupe puis sur la carte
                variables.markers.push(marker);
                markersCluster.addLayer(marker);
                map.addLayer(markersCluster);
                variables.group = new L.featureGroup(variables.markers);
                map.fitBounds(variables.group.getBounds().pad(0));

                if (variables.shortcodeTemplateValue === 'full') {

                  // Affichage des horaires
                  let scheduleText = '';
                  let scheduleTextList = '';
                  let scheduleNotSpecifiedClass = '';
                  if (schedule) {
                    if (schedule === 'Horaires non renseignés') {
                      scheduleNotSpecifiedClass = ' schedules-not-specified';
                    }
                    scheduleText = `<span class="text__schedule${scheduleNotSpecifiedClass}">${schedule}</span>`;
                    scheduleTextList += `<div class="item__extra"><div class="extra__wrapper">`;

                    cl(fullSchedule);
                    for (const property in fullSchedule) {
                      let scheduleValue;
                      if (fullSchedule[property] !== '') {
                        scheduleValue = fullSchedule[property];
                      } else {
                        scheduleValue = 'Fermé';
                      }
                      scheduleTextList += `<div class="extra__schedule"><span class="schedule__weekday">${property}</span><span class="schedule__value">${scheduleValue}</span></div>`;
                    }
                    scheduleTextList += `</div></div>`;
                  }

                  // Affichage de l'adresse
                  const addressText = !!address ? `<a class="text__address" target="_blank" href="${urlMapsSelector(latitude, longitude)}">${address}</a>` : '';

                  // Affichage du siteweb
                  const websiteText = !!website ? `<a class="text__website" href="${website}" target="_blank">Website</a>` : '';

                  // Affichage du numéro de téléphone
                  const phoneText = !!phone ? `<a href="tel:${phone}" class="text__phone">${phone}</a>` : '';

                  const contentStoreContainer = `<div class="container__item ${type} ${secondary_type}" style="--markerColor:${bgColor};" id="item-${id}" data-display="true" data-marker="${id}">
                        <div class="item__text">
                          <div class="item__text--column">
                            <div class="text__crosshairs">
                              <h3 class="text__title">${name}</h3>
                            </div>
                            ${addressText}
                          </div>
                          <div class="item__text--column">
                            ${websiteText}
                            ${phoneText}
                            ${!fullScheduleClosed ? scheduleText : ''}
                            ${!fullScheduleClosed ? scheduleTextList : ''}
                          </div>
                        </div>
                      </div>`;
                  storesContainer.insertAdjacentHTML('beforeend', contentStoreContainer);

                  /*------------ [EVENT] Liste ------------*/
                  listEvent(map, marker, id, fullSchedule, variables.markers, markersCluster);
                }
              }
            }
          }
        });

        /*------------ [EVENT] Marker Cluster ------------*/
        markerClusterEvents(variables.markers, markersCluster);

        /*------------ [EVENT] Marker ------------*/
        markerEvent(map, markersCluster);

        /*------------ [GEOLOCATION] ------------*/
        if (variables.shortcodeGeolocalisationValue === 'true') {
          geolocation(map, variables.group);
        }
        /*------------ [RESET LOCATION] ------------*/
        resetLocation(map, variables.group);

        if (variables.shortcodeTemplateValue === 'full') {
          /*------------ [FILTERS] Create ------------*/
          createFilters(variables.arrayTypesCategories, variables.arrayCategories, variables.group, types);

          /*------------ [OVERLAYSCROLLBAR] ------------*/
          makeScrollbar(storesContainer, "os-theme-dark", true);

          /*------------ [SEARCH] append & events  ------------*/
          search(variables.markers, markersCluster, map);
        }
      };

      /*------------ [AJAX] error ------------*/
      const error = err => { cl(err) };

      /*------------ [AJAX] ------------*/
      ajax(variables.params, success, error, 'json');

      /*------------Template onlyMap Exception------------*/
      if (variables.shortcodeTemplateValue !== 'full') {
        const removeElement = id => {
          const element = document.getElementById(id);
          if (element) {
            element.remove();
          }
        };
        removeElement('map__stores');
        removeElement('searchTab');
        if (variables.mapContainer) {
          variables.mapContainer.classList.remove('col-md-7');
          variables.mapContainer.classList.remove('col-lg-8');
          variables.mapContainer.classList.remove('col-xl-9');
        }
      }

    }
  }
}
